import { Icon } from "@chakra-ui/react"
import React from "react"
const BellIcon = props => {
  return (
    <Icon
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 512 512"
      {...props}
    >
      <path d="M444.32 356.52L421 340.973V206c0-85.925-66.023-156.707-150-164.311V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v26.689C157.023 49.293 91 120.075 91 206v134.973L67.68 356.52A14.996 14.996 0 0061 369v60c0 8.284 6.716 15 15 15h98.875c7.041 38.627 40.726 68 81.125 68 40.398 0 74.084-29.373 81.125-68H436c8.284 0 15-6.716 15-15v-60c0-5.016-2.507-9.699-6.68-12.48zM256 482c-23.789 0-43.935-16.059-50.359-38H306.36c-6.425 21.941-26.571 38-50.36 38zm165-68H91v-36.973l23.32-15.547A14.998 14.998 0 00121 349V206c0-74.439 60.561-135 135-135s135 60.561 135 135v143c0 5.016 2.507 9.699 6.68 12.48L421 377.027V414z" />
    </Icon>
  )
}

export default BellIcon
